import MgrFirebase from "../managers/mgr-firebase";
import MgrApns from "../managers/mrg-apns";
import MgrBase from "../managers/mrg-base";
import ApnsApp from "../models/apns-app";
import FirebaseApp from "../models/firebase-app";
import { isSafari } from "../utils/apple";

export default class PushHelper {
    static #_instance;

    static getInstance(config): MgrBase {
        if (!PushHelper.#_instance) {
            if (!config) {
                throw new Error("Fist call of getInstance must have config object to initialize manager");
            }
            if (isSafari()) {
                PushHelper.#_instance = new MgrApns(new ApnsApp(config));
            } else {
                PushHelper.#_instance = new MgrFirebase(new FirebaseApp(config));
            }
        }
        return PushHelper.#_instance;
    }
}
